var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditTemp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9735_16117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 62C48.1208 62 62 48.1208 62 31C62 13.8792 48.1208 0 31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62Z",
    fill: "#BA63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1353 47.1907L29.9233 61.9788C38.2118 62.2651 46.5932 59.2468 52.9203 52.9199C58.3918 47.4484 61.3898 40.4403 61.9155 33.2847L45.4783 16.8477L15.1353 47.1907Z",
    fill: "#A041FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8096 44.7845L19.1558 46.0737L16.9288 45.0712L15.9263 42.8442L17.2156 37.1904L22.2211 39.7789L24.8096 44.7845Z",
    fill: "#EEEAE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8095 44.7839L19.1557 46.0731L16.9287 45.0706L22.221 39.7783L24.8095 44.7839Z",
    fill: "#DBD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9261 42.8438L14.9722 47.0273L19.1557 46.0733L15.9261 42.8438Z",
    fill: "#00347B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1069 17.293L44.6998 24.8858L24.8103 44.7753L17.2174 37.1825L37.1069 17.293Z",
    fill: "#FFD944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5409 44.459L14.9722 47.0277L19.1557 46.0738L17.5409 44.459Z",
    fill: "#002659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9038 21.0889L44.7002 24.8853L24.8107 44.7748L21.0143 40.9784L40.9038 21.0889Z",
    fill: "#FF9E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5457 24.0481L37.9517 16.454L39.5425 14.8632C40.6335 13.7722 42.4025 13.7722 43.4935 14.8632L47.1365 18.5062C48.2276 19.5973 48.2276 21.3662 47.1365 22.4572L45.5457 24.0481Z",
    fill: "#75E68C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1368 18.5061L45.3154 16.6846L41.749 20.2509L45.546 24.0479L47.1368 22.4571C48.2279 21.3661 48.2279 19.5971 47.1368 18.5061Z",
    fill: "#00CB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.29 16.1084L45.8829 23.7013L43.5157 26.0685L35.9228 18.4756L38.29 16.1084Z",
    fill: "#EEEAE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0869 19.9043L45.8833 23.7007L43.5161 26.0679L39.7197 22.2715L42.0869 19.9043Z",
    fill: "#DBD1CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9735_16117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTemp);
export default __webpack_public_path__ + "static/media/editTemp.ab72b0440c6040e0212c8460fc05cea3.svg";
export { ForwardRef as ReactComponent };